import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notifications: []
};

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        addNotification: (state, action) => {
            const notification = {
                id: Date.now() + Math.random(),
                message: action.payload.message,
                type: action.payload.type || 'info', // success, error, warning, info
                duration: action.payload.duration || 5000,
                timestamp: Date.now()
            };
            state.notifications.push(notification);
        },
        removeNotification: (state, action) => {
            state.notifications = state.notifications.filter(
                notification => notification.id !== action.payload
            );
        },
        clearAllNotifications: (state) => {
            state.notifications = [];
        }
    }
});

export const { addNotification, removeNotification, clearAllNotifications } = notificationSlice.actions;

// Helper action creators for common notification types
export const showSuccessNotification = (message, duration) =>
    addNotification({ message, type: 'success', duration });

export const showErrorNotification = (message, duration) =>
    addNotification({ message, type: 'error', duration });

export const showWarningNotification = (message, duration) =>
    addNotification({ message, type: 'warning', duration });

export const showInfoNotification = (message, duration) =>
    addNotification({ message, type: 'info', duration });

export default notificationSlice.reducer;
